import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { fmtCurrency } from "../../lib/format";
import { COLORS } from "./theme";

export default function CapitalStackCard({ agg, currency }) {
  const data = [
    { name: "Equity", value: Math.max(0, Number(agg.total_equity || 0)) },
    { name: "Total Debt", value: Math.max(0, Number(agg.total_debt || 0)) },
    {
      name: "Other Liab.",
      value: Math.max(
        0,
        Number(agg.total_liabilities || 0) - Number(agg.total_debt || 0)
      ),
    },
  ];
  const fills = [COLORS.primary, COLORS.accent, COLORS.sand];
  const total = data.reduce((acc, d) => acc + d.value, 0);
  return (
    <Card className="lg:col-span-4 bg-white border-[#E5E0D8] shadow-none" data-testid="capital-stack-card">
      <CardHeader className="pb-1">
        <CardDescription className="text-xs uppercase tracking-[0.18em] text-[#5C665D]">Capital stack</CardDescription>
        <CardTitle className="font-serif-display text-2xl text-[#1F382E]">How the business is funded.</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-44">
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                innerRadius={45}
                outerRadius={75}
                paddingAngle={2}
                stroke="none"
              >
                {data.map((_, i) => (
                  <Cell key={i} fill={fills[i % fills.length]} />
                ))}
              </Pie>
              <Tooltip
                formatter={(v) => fmtCurrency(v, currency)}
                contentStyle={{ background: "#fff", border: `1px solid ${COLORS.border}`, borderRadius: 8 }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="space-y-1.5 mt-2">
          {data.map((d, i) => (
            <div key={d.name} className="flex items-center justify-between text-sm">
              <span className="flex items-center gap-2 text-[#1A1A1A]">
                <span className="h-2 w-2 rounded-sm" style={{ background: fills[i] }} />
                {d.name}
              </span>
              <span className="tabular-nums text-[#1F382E]">
                {total > 0 ? `${((d.value / total) * 100).toFixed(0)}%` : "—"}
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
